module.exports = __webpack_public_path__ + "static/img/zhangtan.68e30fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus/zhangtan.png
// module id = WJjG
// module chunks = 6